import env from '@config/env';
import { getDefaultHomePath } from '@config/routes';
import PageLoader from '@loaders/PageLoader';
import { isChunkLoadError } from '@utils/chunkLoadError';
import { Result, Button } from 'antd';
import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, recovering: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, recovering: isChunkLoadError(error) };
  }

  componentDidCatch(error, errorInfo) {
    if (isChunkLoadError(error)) return;

    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, recovering: false });
    window.location.href = getDefaultHomePath();
  };

  render() {
    if (this.state.recovering || isChunkLoadError(this.state.error)) {
      return <PageLoader />;
    }

    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center p-3 desktop:p-4">
          <Result
            status="error"
            title="Something went wrong"
            subTitle={this.state.error?.message || 'An unexpected error occurred'}
            extra={
              <Button type="primary" onClick={this.handleReset}>
                {env.APP_TYPE === 'merchant' ? 'Go to Launch Pad' : 'Go to Dashboard'}
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
